import "./GradientWrapper.scss"
import { Box, BoxProps } from "@mui/material"
import React, { ReactNode } from "react"
import classNames from "classnames"

interface Props extends BoxProps {
  borderRadius: string
  children?: ReactNode
  background?: string
}

function GradientWrapper({
  borderRadius,
  children,
  background,
  className,
  ...props
}: Props) {
  return (
    <Box
      className={classNames("component-gradient-wrapper", className)}
      borderRadius={borderRadius}
      {...props}
    >
      <Box
        className="inner-container"
        borderRadius={borderRadius}
        style={background ? { background } : undefined}
      >
        {children}
      </Box>
    </Box>
  )
}

export default GradientWrapper
